import SimpleInput from "../Components/MastersForm"

const MasterForm=()=>{

    return(
        <SimpleInput/>
    )
}

export default MasterForm;